import React from 'react';
import SpeedBoostShoes from './speedBoostShoes.js';
import BestMarathonShoes from './pages/BestMarathonShoes.js';
import CarbonPlateExplained from './pages/CarbonPlateExplained.js';
import AlphaflyVsVaporfly from './pages/AlphaflyVsVaporfly.js';
import AlphaflyVsAdiosPro4 from './pages/AlphaflyVsAdiosPro4.js';
import VaporflyVsMetaspeed from './pages/VaporflyVsMetaspeed.js';
import HowMuchFaster from './pages/HowMuchFaster.js';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <Routes>
      <Route path="/" element={<SpeedBoostShoes />} />
      <Route path="/best-marathon-racing-shoes-2025" element={<BestMarathonShoes />} />
      <Route path="/carbon-plate-running-shoes-explained" element={<CarbonPlateExplained />} />
      <Route path="/nike-alphafly-vs-vaporfly" element={<AlphaflyVsVaporfly />} />
      <Route path="/alphafly-3-vs-adios-pro-4" element={<AlphaflyVsAdiosPro4 />} />
      <Route path="/vaporfly-4-vs-metaspeed-sky-paris" element={<VaporflyVsMetaspeed />} />
      <Route path="/how-much-faster-do-super-shoes-make-you" element={<HowMuchFaster />} />
    </Routes>
  );
}

export default App;
